import apiClient from './apiClient';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export const kvaApi = {
  /**
   * Alle Kostenvoranschläge abrufen (mit optionalen Filtern)
   */
  getKvas: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.kundeId) queryParams.append('kundeId', params.kundeId);
    if (params.anfrageId) queryParams.append('anfrageId', params.anfrageId);
    if (params.status) queryParams.append('status', params.status);

    const queryString = queryParams.toString();
    const url = queryString ? `/kostenvoranschlaege?${queryString}` : '/kostenvoranschlaege';

    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * Einzelnen Kostenvoranschlag abrufen
   */
  getKva: async (id) => {
    const response = await apiClient.get(`/kostenvoranschlaege/${id}`);
    return response.data;
  },

  /**
   * Neuen Kostenvoranschlag erstellen
   */
  createKva: async (data) => {
    const response = await apiClient.post('/kostenvoranschlaege', data);
    return response.data;
  },

  /**
   * Kostenvoranschlag aktualisieren
   */
  updateKva: async (id, data) => {
    const response = await apiClient.put(`/kostenvoranschlaege/${id}`, data);
    return response.data;
  },

  /**
   * Kostenvoranschlag löschen
   */
  deleteKva: async (id) => {
    const response = await apiClient.delete(`/kostenvoranschlaege/${id}`);
    return response.data;
  },

  /**
   * PDF-URL für einen Kostenvoranschlag generieren
   */
  getPdfUrl: (kva) => {
    if (!kva.pdfPfad) return null;
    return `${API_URL}${kva.pdfPfad}`;
  },

  /**
   * Kostenvoranschlag per E-Mail versenden
   */
  sendKva: async (id) => {
    const response = await apiClient.post(`/kostenvoranschlaege/${id}/send`);
    return response.data;
  },

  /**
   * KVA/Angebot → Rechnung konvertieren (liefert vorausgefüllte Daten)
   */
  convertToRechnung: async (id) => {
    const response = await apiClient.post(`/kostenvoranschlaege/${id}/convert-to-rechnung`);
    return response.data;
  },

  // --- Auftragsbestätigung (AB) ---

  /**
   * Auftragsbestätigung aus Angebot/KVA erstellen
   */
  createAB: async (id, data = {}) => {
    const response = await apiClient.post(`/kostenvoranschlaege/${id}/create-ab`, data);
    return response.data;
  },

  /**
   * AB per E-Mail versenden
   */
  sendAB: async (id) => {
    const response = await apiClient.post(`/kostenvoranschlaege/${id}/send-ab`);
    return response.data;
  },

  /**
   * AB → Rechnung konvertieren (liefert vorausgefüllte Daten)
   */
  convertAbToRechnung: async (id) => {
    const response = await apiClient.post(`/kostenvoranschlaege/${id}/convert-ab-to-rechnung`);
    return response.data;
  },

  /**
   * AB-PDF URL
   */
  getAbPdfUrl: (kva) => {
    if (!kva.abPdfPfad) return null;
    return `${API_URL}${kva.abPdfPfad}`;
  }
};

export default kvaApi;
